import Events from "@/event/Events";
import VueSignature from "vue-signature-pad";

export default {
    install(Vue, options) {
        Vue.mixin(Events);
        Vue.use(VueSignature);
    }
}
